import React, { useState, useEffect } from "react";
import ERxListPrescription from "../../../ManualRX/ERxListPrescription";
import {
  GET_SAVED_E_PRESCRIPTIONS,
  GET_SHARED_E_PRESCRIPTIONS,
} from "../../ERXViewApiHandler/apiConstants";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import "./sspView.scss";
import Loader from "../../../UI Component/Loader/Loader";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const SSPView = (props) => {
  const {
    pharmacyList,
    appointmentData,
    handleEditCall,
    getPastConsultationsApi,
    includeInErx,
    handleSharePharmacyBtn,
  } = props;

  const [erx_counter, setERXCounter] = useState(0);
  const [savedPrescriptions, setSavedPrescriptions] = useState([]);
  const [sharedPrescriptions, setSharedPrescriptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const user_id = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  useEffect(() => {
    fetchSharedPrescriptions();
    fetchSavedPrescriptions();
  }, []);

  const fetchSavedPrescriptions = () => {
    let payload = {
      "authorizer-principal-id": {
        user_type: "1",
        user_id: appointmentData?.doctor_id
          ? appointmentData?.doctor_id
          : user_id,
      },
      user_id: appointmentData?.doctor_id
        ? appointmentData?.doctor_id
        : user_id,
      appointment_id: appointmentData?.appointment_id,
    };
    setLoader(true);
    c2cPostApiHandler(GET_SAVED_E_PRESCRIPTIONS, payload)
      .then(([res, error]) => {
        if (!error) {
          if (res?.data?.statusCode === 200) {
            setSavedPrescriptions(res?.data?.data);
          }
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const fetchSharedPrescriptions = () => {
    let payload = {
      "authorizer-principal-id": {
        user_type: "1",
        user_id: appointmentData?.doctor_id
          ? appointmentData?.doctor_id
          : user_id,
      },
      user_id: appointmentData?.doctor_id
        ? appointmentData?.doctor_id
        : user_id,
      appointment_id: appointmentData?.appointment_id,
    };
    setLoader(true);
    c2cPostApiHandler(GET_SHARED_E_PRESCRIPTIONS, payload)
      .then(([res, error]) => {
        if (!error) {
          if (res?.data?.statusCode === 200) {
            setSharedPrescriptions(res?.data?.data);
          }
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <div className="erx-saved-and-shared">
      {loader && <Loader />}
      <ERxListPrescription
        {...props}
        pharmacyList={pharmacyList}
        appointment_id={appointmentData?.appointment_id}
        erx_counter={erx_counter}
        appointmentData={appointmentData}
        onEditCallBack={(id) => {
          handleEditCall(id);
        }}
        setERXCounter={() => setERXCounter(erx_counter + 1)}
        fetchSavedPrescriptions={fetchSavedPrescriptions}
        fetchSharedPrescriptions={fetchSharedPrescriptions}
        getPastConsultationsApi={getPastConsultationsApi}
        includeInErx={includeInErx}
        savedPrescriptions={savedPrescriptions}
        sharedPrescriptions={sharedPrescriptions}
        handleSharePharmacyBtn={handleSharePharmacyBtn}
      />
    </div>
  );
};

export default SSPView;
